import { httpService } from 'src/services/app/http.service'
import { SUPPORT_ENDPOINTS } from 'src/services/consts/api.const'

export const supportService = {
  submitSupportRequest,
}

/**
 * @param {{ topic: string, message: string }} params
 * @returns {Promise<unknown>}
 */
async function submitSupportRequest({ topic, message }) {
  const payload = {
    topic,
    problem_description: message,
  }

  return httpService.post(SUPPORT_ENDPOINTS.NEW_TICKET, payload)
}
